module.exports = __webpack_public_path__ + "static/media/heart.71406c00.svg";